module.exports = __webpack_public_path__ + "static/media/emhyr.6bd7fa93.png";